import * as React from "react";
import { Alert, Button, ControlLabel, FormControl, FormGroup, InputGroup, } from "react-bootstrap";
import { ComponentEx, connect, translate } from "../../controls/ComponentEx";
import More from "../../controls/More";
import { UPDATE_CHANNELS } from "../../types/IState";
import Debouncer from "../../util/Debouncer";
import { log } from "../../util/log";
import { setUpdateChannel } from "./actions";
const CHECK_UPDATE_INTERVAL = 60000;
class SettingsUpdate extends ComponentEx {
    //static contextType = MainContext
    constructor(props) {
        super(props);
        this.initState({
            checkUpdateButtonDisabled: false,
        });
    }
    checkUpdateDebouncer = new Debouncer(() => {
        this.checkNow();
        setTimeout(() => {
            this.nextState.checkUpdateButtonDisabled = false;
        }, CHECK_UPDATE_INTERVAL);
        return null;
    }, CHECK_UPDATE_INTERVAL, true, true);
    manualUpdateCheck = () => {
        this.nextState.checkUpdateButtonDisabled = true;
        log("info", "manual update check");
        this.checkUpdateDebouncer.schedule();
    };
    render() {
        const { t, installType, updateChannel } = this.props;
        const { checkUpdateButtonDisabled } = this.state;
        const renderDevelopmentAlert = () => {
            if (process.env.NODE_ENV === "development")
                return (React.createElement("div", null,
                    React.createElement(ControlLabel, null,
                        React.createElement(Alert, null, t("Vortex is running in development mode. Updates will be checked and downloaded but can't be installed.")))));
            return null;
        };
        const renderPreviewAlert = () => {
            if (updateChannel === "next")
                return (React.createElement("div", null,
                    React.createElement(ControlLabel, null,
                        React.createElement(Alert, null, t("Vortex is running in preview mode and using the hidden 'next' update channel.")))));
            return null;
        };
        // managed or development
        if (installType === "managed") {
            // managed and not development
            if (process.env.NODE_ENV !== "development") {
                return (React.createElement("div", null,
                    React.createElement(ControlLabel, null,
                        React.createElement(Alert, null, t("Vortex was installed through a third-party service which will take care of updating it.")))));
            }
            // managed and development
        }
        // regular
        return (React.createElement("form", null,
            React.createElement(FormGroup, { controlId: "updateChannel" },
                renderDevelopmentAlert(),
                React.createElement(ControlLabel, null,
                    t("Update"),
                    React.createElement(More, { id: "more-update-channel", name: t("Update Channel") }, t("You can choose to either receive automatic updates only after they went through some " +
                        "community testing (Stable) or to always get the newest features (Beta). Manual checking for updates is " +
                        "restricted to every 10 minutes."))),
                React.createElement(InputGroup, null,
                    React.createElement(FormControl, { componentClass: "select", value: updateChannel, onChange: this.selectChannel },
                        React.createElement("option", { value: "stable" }, t("Stable")),
                        React.createElement("option", { value: "beta" }, t("Beta")),
                        React.createElement("option", { value: "none" }, t("No automatic updates"))),
                    React.createElement(Button, { disabled: checkUpdateButtonDisabled, key: "manual-update-button", onClick: this.manualUpdateCheck }, t("Check now"))),
                renderPreviewAlert(),
                React.createElement("div", null,
                    React.createElement(ControlLabel, null, updateChannel === "none" ? (React.createElement(Alert, { bsStyle: "warning", key: "manual-update-warning" }, t("Very old versions of Vortex will be locked out of network features eventually " +
                        "so please do keep Vortex up-to-date."))) : null)))));
    }
    checkNow = () => {
        // send what updateChannel you are on, unless it's none, then send stable. manual check as well
        const channel = this.props.updateChannel === "none" ? "stable" : this.props.updateChannel;
        window.api.updater.checkForUpdates(channel, true);
    };
    selectChannel = (evt) => {
        const target = evt.target;
        if (UPDATE_CHANNELS.includes(target.value)) {
            const newChannel = target.value;
            if (newChannel === "beta") {
                this.context.api.showDialog("question", "Switching to Beta update channel", {
                    text: `Development versions of Vortex can be unstable and cause irreparable damage to your modding environment. 

We recommend using the Beta channel only if you are comfortable with the risks and are willing to report any issues you encounter. We don't recommend downgrading back from beta to stable.

Are you sure you want to switch to the Beta update channel?`,
                }, [
                    { label: "Cancel" },
                    {
                        label: "Switch to Beta",
                        action: () => this.props.onSetUpdateChannel(newChannel),
                    },
                ]);
            }
            else if (newChannel === "stable") {
                // stable or latest
                this.props.onSetUpdateChannel(newChannel);
            }
            else if (newChannel === "none") {
                // none
                this.context.api.showDialog("question", "Turning off updates", {
                    text: `This will stop notifications about Vortex updates.

This is not recommended as important security and stability updates are released regularly.

Are you sure you want to turn off updates?`,
                }, [
                    { label: "Cancel" },
                    {
                        label: "Turn off updates",
                        action: () => this.props.onSetUpdateChannel(newChannel),
                    },
                ]);
            }
        }
        else {
            log("error", "invalid channel", target.value);
        }
    };
}
function mapStateToProps(state) {
    return {
        updateChannel: state.settings.update.channel,
        installType: state.app.installType,
    };
}
function mapDispatchToProps(dispatch) {
    return {
        onSetUpdateChannel: (channel) => {
            dispatch(setUpdateChannel(channel));
        },
    };
}
export default translate(["common"])(connect(mapStateToProps, mapDispatchToProps)(SettingsUpdate));
